export class AnagraficaDto {
  public IdAnagraficaUtente : number = 0;
  public IdAnagraficaUtenteEnc : string = '';
  public IdUser : number = 0;
  public Nome : string = '';
  public Cognome : string = '';
  public CognomeNome : string = '';
  public Sesso : string = '';
  public DataNascita : Date = new Date();
  public DataNascitaSTR : string = '';
  public Eta : number = 0;
  public IdNazioneCittadinanza : number = 0;
  public NazioneCittadinanza : string = '';
  public IdComuneNascita : number = 0;
  public ComuneNascita : string = '';
  public CodiceFiscale : string = '';
  public Email : string = '';
  public Cellulare : string = '';
  public TelefonoFisso : string = '';
  public IdStatoCivile : number = 0;
  public Stato : number = 0;
  public IdComuneDomicilio : number = 0;
  public ComuneDomicilio : string = '';
  public IdComuneResidenza : number = 0;
  public ComuneResidenza : string = '';
  public ResidenzaCombaciaConDomicilio : boolean = false;
  public IndirizzoResidenza : string = '';
  public IndirizzoDomicilio : string = '';
  public Valutazione : number = 0;
  public DataUltimoAggiornamentoCV : Date = new Date();
  public DataUltimoAggiornamentoCVSTR : string = '';
  public StatoOccupazione : string = '';
  public IsOccupato : boolean = false;
  public IsInForza : boolean = false;
  public NrCandidatureAttive : number = 0;
  public InOrdine : boolean = false;
  public InCTP : boolean = false;
  public InRDA : boolean = false;
  public PrivacyAccettata : boolean = false;
  public PrivacyAccettataData : Date = new Date();
  public InfoIscrizione : string = '';
  public IdAziendaReferente : number = 0;
  public IdAzienda : number = 0;
  public RagioneSociale : string = '';
  public IdLivelloIstruzioneMax : number = 0;
  public IdStatoLavorativo : number = 0;
  public CategoriaProtetta : boolean = false;
  public Automunito : boolean = false;
  public DisponibilitaFrequentareCorsi : boolean = false;
  public DisponibilitaPolitcheAttive : boolean = false;
  public DisponibilitaCorsi : boolean = false;
  public DetrazioniLavoratoreDipendente : boolean = false;
  public SceltaTFR : string = '';
  public InserisciMatricola : boolean = false;
  public StatoAbilitazioneFirma : number = 0;
  public VisibilitaPulsanteFirma : boolean = false;
  public DecretoDignitaSuccessivo : number = 0;
  public IdFilialeMailSostitutiva : number = 0;
  public Contatore : number = 0;
  public LimiteMassimoGiorni : number = 0;
  public LimiteMassimoGiorniSingoloUtilizzatore : number = 0;
  public CanEditLimiteMassimoGiorni : boolean = false;
  public TotaleMaturatoGiorni : number = 0;
  public PeriodoResiduoMaturazioneDirittoGiorni : number = 0;
  public DateIns : Date = new Date();
  public DateInsStr : string = '';

  /* parte cv */
  public IdDisponibilitaOrario : number = 0;
  public DisponibilitaOrarioList : string = "";
  public IdCorsoList : string = "";
  public PatenteA : boolean = false;
  public PatenteB : boolean = false;
  public PatenteC : boolean = false;
  public PatenteD : boolean = false;
  public PatenteE : boolean = false;

  public AccettoInvioEmailFlag : boolean = false;
}

export class AnagraficaUtenteVarieCVDataDto {
  public VarieCV : AnagraficaUtenteVarieCVDto = new AnagraficaUtenteVarieCVDto();
  public DisponibilitaOrario : AnagraficaUtenteDisponibilitaOrarioDto[] = [];
  public CorsiFormazione : AnagraficaUtenteCorsoFormazioneDto[] = [];
}

export class AnagraficaUtenteVarieCVDto{
  public IdAnagraficaUtenteVarieCV : number = 0;
  public IdAnagraficaUtente : number = 0;
  public IdDisponibilitaOrario : number  = 0;
  public DisponibilitaFrequentareCorsi : boolean = false;
  public DisponibilitaPolitcheAttive : boolean = false;
  public CategoriaProtetta : boolean = false;
  public PatenteA : boolean = false;
  public PatenteB : boolean = false;
  public PatenteC : boolean = false;
  public PatenteD : boolean = false;
  public PatenteE : boolean = false;
  public Automunito : boolean = false;
}

export class AnagraficaUtenteDisponibilitaOrarioDto {
  public IdDisponibilitaOrario : number = 0;
  public DisponibilitaOrario : string = "";
  public Key : number = 0;
  public Value : string = "";
}

export class AnagraficaUtenteCorsoFormazioneDto {
  public IdAnagraficaUtenteCorsi : number = 0;
  public IdAnagraficaUtente : number = 0;
  public IdCorso : number = 0;
  public CorsoDesc : string = "";
}

export class CandidatureGetListViewModel{
  public IdAnagraficaUtente : number = 0;
}

export class AnagraficaUtenteCandidature{
  public IdCommessaAnnuncio : number = 0;
  public Titolo : string = "";
  public DataCandidatura : Date = new Date();
  public DataCandidaturaStr : string = "";
  public StatoCommessa : number = 0;
  public DataScadenza : Date = new Date();
  public DataScadenzaStr : string = "";
  public IdPostingProvider : number = 0;
  public PostingProviderDesc : string = "";
  public Filiale : string = "";
  public IdCommessa : number = 0;
}

export class AnagraficaUtentePortalePagineCompilate{
  public PaginaAnagrafica : boolean = false;
  public PaginaLavoro : boolean = false;
  public PaginaIstruzione : boolean = false;
  public PaginaPreferenze : boolean = false;
  public PaginaDocumenti : boolean = false;
  public Rating : number = 0;
  public RatingTitle : string = "";
  public RatingSubTitle : string = "";
}
